import { useEffect, useMemo, useState } from 'react';
import { consentService } from '@/services/consent';
import { thirdPartyServices } from '@/services/thirdPartyServices';
import { ConsentContext, type ConsentContextValue } from './consent-context';

export function ConsentProvider({ children }: { children: React.ReactNode }) {
  const [snapshot, setSnapshot] = useState(() => consentService.getSnapshot());

  useEffect(() => {
    const unsubscribe = consentService.subscribe(setSnapshot);
    thirdPartyServices.initialize();
    void consentService.initialize();
    return unsubscribe;
  }, []);

  const value = useMemo<ConsentContextValue>(
    () => ({
      ...snapshot,
      canUse: (category) => snapshot.categories[category] === true,
      openPreferences: () => consentService.openPreferences(),
    }),
    [snapshot]
  );

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

